import React, { useState } from "react";
import { Paper } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import moment from "moment";

export const SingleCampaign = ({ item, updateEndDate, updateStartDate }) => {
  const [startDate, setStartDate] = useState(
    moment(item.StartDate).format("YYYY-MM-DDTHH:mm"),
  );
  const [endDate, setEndDate] = useState(
    moment(item.EndDate).format("YYYY-MM-DDTHH:mm"),
  );
  const [startDatepickerActive, setStartDatePickerActive] = useState(false);
  const [endDatePickerActive, setEndDatePickerActive] = useState(false);
  const [enableUpdateNewDate, setEnableNewDate] = useState(false);
  const [queueToSendStartDate, setQueueToSendStartDate] = useState(false);
  const [queueToSendEndDate, setQueueToSendEndDate] = useState(false);

  return (
    <Paper
      className="col-sm-12 col-md-8 col-lg-6 col-xl-3"
      style={{ margin: "10px 10px", padding: "10px 10px" }}
    >
      Name: {item.Name} <br />
      Bonus in sek: {item.BonusInSek} <br />
      Bonus in eur: {item.BonusInEur} <br />
      Target amount in sek: {item.TargetInSek} <br />
      Target amount in eur: {item.TargetInEur} <br />
      Days to reach target: {item.DaysToReachTarget} <br />
      <br />
      Start date:{" "}
      {startDatepickerActive ? (
        <React.Fragment>
          <TextField
            id="datetime-local"
            label="Start date swedish time"
            type="datetime-local"
            value={startDate}
            InputLabelProps={{ shrink: true }}
            onChange={(event) => {
              setQueueToSendStartDate(true);
              setStartDate(event.target.value);
              setEnableNewDate(true);
              setStartDatePickerActive(false);
            }}
          />
          <br />
        </React.Fragment>
      ) : (
        <React.Fragment>
          {startDate}{" "}
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setStartDatePickerActive(true);
            }}
          >
            Edit
          </Button>
          <br />
        </React.Fragment>
      )}
      End date:
      {endDatePickerActive ? (
        <React.Fragment>
          <TextField
            id="datetime-local"
            label="End date swedish time"
            type="datetime-local"
            value={endDate}
            InputLabelProps={{ shrink: true }}
            onChange={(event) => {
              setQueueToSendEndDate(true);
              setEndDate(event.target.value);
              setEnableNewDate(true);
              setEndDatePickerActive(false);
            }}
          />
          <br />
        </React.Fragment>
      ) : (
        <React.Fragment>
          {" "}
          {endDate}{" "}
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setEndDatePickerActive(true);
            }}
          >
            Edit
          </Button>
          <br />
        </React.Fragment>
      )}
      <br />
      {enableUpdateNewDate && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            if (queueToSendStartDate) updateStartDate(startDate, item.Id);

            if (queueToSendEndDate) updateEndDate(endDate, item.Id);
          }}
        >
          {" "}
          Update{" "}
        </Button>
      )}
    </Paper>
  );
};

export default SingleCampaign;
